/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _circle, _circle2, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _circle3, _path108, _path109, _circle4, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _circle5, _path138, _path139, _circle6, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _circle7, _circle8, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _circle9, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _circle0, _path229, _circle1, _path230, _path231, _circle10, _path232, _circle11, _path233, _path234, _path235, _circle12, _path236, _circle13, _path237, _path238, _circle14, _path239, _circle15, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _circle16, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _circle17, _circle18, _circle19, _circle20, _circle21, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _circle22, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363;
const ChatLaunch = /*#__PURE__*/React.forwardRef(function ChatLaunch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v4a1.9965,1.9965,0,0,1-2,2H20l-4,7,1.7358,1,3.4288-6H26a3.9992,3.9992,0,0,0,4-4V16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4,20V8A1.9965,1.9965,0,0,1,6,6H18V4H6A3.9986,3.9986,0,0,0,2,8V20a3.9992,3.9992,0,0,0,4,4h9V22H6A1.9965,1.9965,0,0,1,4,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChatLaunch.propTypes = iconPropTypes;
}
const ChatOff = /*#__PURE__*/React.forwardRef(function ChatOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8V21h2V8a3.9986,3.9986,0,0,0-4-4H8.2429l2,2H26A1.9965,1.9965,0,0,1,28,8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.5859,3.4141,2,2,3.4141,3.5039,4.918A3.9181,3.9181,0,0,0,2,8V20a3.9992,3.9992,0,0,0,4,4h6V22H6a1.9965,1.9965,0,0,1-2-2V8a1.9814,1.9814,0,0,1,.9194-1.6665L20.5859,22H17l-4,7,1.7358,1,3.4288-6h4.4213l6,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChatOff.propTypes = iconPropTypes;
}
const ChatOperational = /*#__PURE__*/React.forwardRef(function ChatOperational({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.586 10.414L19.166 14 19.166 14 15.584 17.587 17 19 22 14 17 9 15.586 10.414z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.586 10.414L24.166 14 24.166 14 20.584 17.587 22 19 27 14 22 9 20.586 10.414z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9L11.593 12 15 12.414 12.5 14.667 13 18 10 16.125 7 18 7.5 14.667 5 12.414 8.5 12 10 9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChatOperational.propTypes = iconPropTypes;
}
const ChatBot = /*#__PURE__*/React.forwardRef(function ChatBot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16,19a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,16,19Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,20,8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,12,8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChatBot.propTypes = iconPropTypes;
}
const Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Checkbox.propTypes = iconPropTypes;
}
const CheckboxChecked = /*#__PURE__*/React.forwardRef(function CheckboxChecked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckboxChecked.propTypes = iconPropTypes;
}
const CheckboxCheckedFilled = /*#__PURE__*/React.forwardRef(function CheckboxCheckedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckboxCheckedFilled.propTypes = iconPropTypes;
}
const CheckboxIndeterminate = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H22V18H10z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckboxIndeterminate.propTypes = iconPropTypes;
}
const CheckboxIndeterminateFilled = /*#__PURE__*/React.forwardRef(function CheckboxIndeterminateFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,18H10V14H22Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckboxIndeterminateFilled.propTypes = iconPropTypes;
}
const Checkmark = /*#__PURE__*/React.forwardRef(function Checkmark({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
      d: "M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
    })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
      d: "M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
      d: "M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Checkmark.propTypes = iconPropTypes;
}
const CheckmarkFilled = /*#__PURE__*/React.forwardRef(function CheckmarkFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
    })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
      d: "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"
    })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"
    })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14 21.591L9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkFilled.propTypes = iconPropTypes;
}
const CheckmarkFilledError = /*#__PURE__*/React.forwardRef(function CheckmarkFilledError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkFilledError.propTypes = iconPropTypes;
}
const CheckmarkFilledWarning = /*#__PURE__*/React.forwardRef(function CheckmarkFilledWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkFilledWarning.propTypes = iconPropTypes;
}
const CheckmarkOutline = /*#__PURE__*/React.forwardRef(function CheckmarkOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkOutline.propTypes = iconPropTypes;
}
const CheckmarkOutlineError = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkOutlineError.propTypes = iconPropTypes;
}
const CheckmarkOutlineWarning = /*#__PURE__*/React.forwardRef(function CheckmarkOutlineWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CheckmarkOutlineWarning.propTypes = iconPropTypes;
}
const Chemistry = /*#__PURE__*/React.forwardRef(function Chemistry({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Chemistry.propTypes = iconPropTypes;
}
const ChemistryReference = /*#__PURE__*/React.forwardRef(function ChemistryReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChemistryReference.propTypes = iconPropTypes;
}
const ChevronDown = /*#__PURE__*/React.forwardRef(function ChevronDown({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 10 6",
      fill: "currentColor",
      ...rest
    }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
      d: "M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
      d: "M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronDown.propTypes = iconPropTypes;
}
const ChevronDownOutline = /*#__PURE__*/React.forwardRef(function ChevronDownOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4142 12.5858L16 19.1714 22.5858 12.5858 24 14 16 22 8 14 9.4142 12.5858z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m30,16c0,7.7197-6.2803,14-14,14S2,23.7197,2,16,8.2803,2,16,2s14,6.2803,14,14Zm-26,0c0,6.6167,5.3833,12,12,12s12-5.3833,12-12-5.3833-12-12-12S4,9.3833,4,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronDownOutline.propTypes = iconPropTypes;
}
const ChevronLeft = /*#__PURE__*/React.forwardRef(function ChevronLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 6 10",
      fill: "currentColor",
      ...rest
    }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
      d: "M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
      d: "M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronLeft.propTypes = iconPropTypes;
}
const ChevronMini = /*#__PURE__*/React.forwardRef(function ChevronMini({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
      d: "M15 9L15 15 9 15z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19L31 31 19 31 31 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronMini.propTypes = iconPropTypes;
}
const ChevronRight = /*#__PURE__*/React.forwardRef(function ChevronRight({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 6 10",
      fill: "currentColor",
      ...rest
    }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
      d: "M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
      d: "M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronRight.propTypes = iconPropTypes;
}
const ChevronSort = /*#__PURE__*/React.forwardRef(function ChevronSort({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
      d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
    })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
      d: "M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronSort.propTypes = iconPropTypes;
}
const ChevronSortDown = /*#__PURE__*/React.forwardRef(function ChevronSortDown({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
      d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronSortDown.propTypes = iconPropTypes;
}
const ChevronSortUp = /*#__PURE__*/React.forwardRef(function ChevronSortUp({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
      d: "M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronSortUp.propTypes = iconPropTypes;
}
const ChevronUp = /*#__PURE__*/React.forwardRef(function ChevronUp({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 10 6",
      fill: "currentColor",
      ...rest
    }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
      d: "M5 0L10 5 9.3 5.7 5 1.4 0.7 5.7 0 5z"
    })), children);
  }
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
      d: "M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronUp.propTypes = iconPropTypes;
}
const ChevronUpOutline = /*#__PURE__*/React.forwardRef(function ChevronUpOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4142 19.4142L16 12.8286 22.5858 19.4142 24 18 16 10 8 18 9.4142 19.4142z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m30,16c0,7.7197-6.2803,14-14,14S2,23.7197,2,16,8.2803,2,16,2s14,6.2803,14,14Zm-26,0c0,6.6167,5.3833,12,12,12s12-5.3833,12-12-5.3833-12-12-12S4,9.3833,4,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChevronUpOutline.propTypes = iconPropTypes;
}
const ChildNode = /*#__PURE__*/React.forwardRef(function ChildNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20c-2.41,0-4.43,1.72-4.9,4h-4.1c-2.21,0-4-1.79-4-4v-8.1c2.28-.46,4-2.48,4-4.9,0-2.76-2.24-5-5-5s-5,2.24-5,5c0,2.41,1.72,4.43,4,4.9v8.1c0,3.31,2.69,6,6,6h4.1c.46,2.28,2.48,4,4.9,4,2.76,0,5-2.24,5-5s-2.24-5-5-5ZM6,7c0-1.65,1.35-3,3-3s3,1.35,3,3-1.35,3-3,3-3-1.35-3-3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChildNode.propTypes = iconPropTypes;
}
const Chip = /*#__PURE__*/React.forwardRef(function Chip({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11V21H21V11Zm8,8H13V13h6Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Chip.propTypes = iconPropTypes;
}
const Choices = /*#__PURE__*/React.forwardRef(function Choices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Choices.propTypes = iconPropTypes;
}
const Comments = /*#__PURE__*/React.forwardRef(function Comments({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3163,9.4912l-8.004-6.997c-.3645-.3186-.8322-.4942-1.3163-.4942H4c-1.1046,0-2,.8954-2,2v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V10.997c0-.577-.2493-1.126-.6837-1.5058ZM28,28H4V4h14v7c0,1.1046.8954,2,2,2h8v15ZM20,11v-7l8,7h-8ZM6,20.084c0-4.041,2.0122-6.2939,5.1763-6.2939,2.1499,0,3.5425.9121,4.3853,2.7686l-1.9434,1.0322c-.3438-1.0664-1.1006-1.7881-2.4419-1.7881-1.6851,0-2.7686,1.2207-2.7686,3.2666v1.8916c0,2.0645,1.0835,3.2334,2.7686,3.2334,1.3584,0,2.2012-.8252,2.5967-1.9092l1.8403,1.084c-.8599,1.7881-2.2871,2.8369-4.437,2.8369-3.1641,0-5.1763-2.0801-5.1763-6.1221ZM16.8193,21.4941c0-2.8711,1.5991-4.6768,4.1611-4.6768,2.5796,0,4.1792,1.8057,4.1792,4.6768,0,2.8896-1.5996,4.7119-4.1792,4.7119-2.562,0-4.1611-1.8223-4.1611-4.7119ZM22.855,22.3369v-1.668c0-1.3408-.7222-2.0811-1.8745-2.0811-1.1348,0-1.8569.7402-1.8569,2.0811v1.668c0,1.3584.7222,2.0986,1.8569,2.0986,1.1523,0,1.8745-.7402,1.8745-2.0986Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Comments.propTypes = iconPropTypes;
}
const ChooseItem = /*#__PURE__*/React.forwardRef(function ChooseItem({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H30V26H28z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChooseItem.propTypes = iconPropTypes;
}
const ChoroplethMap = /*#__PURE__*/React.forwardRef(function ChoroplethMap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ChoroplethMap.propTypes = iconPropTypes;
}
const CicsCmas = /*#__PURE__*/React.forwardRef(function CicsCmas({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3335,30H26V28h4V26H28a2.002,2.002,0,0,1-2-2V21.6665A1.6684,1.6684,0,0,1,27.6665,20H32v2H28v2h2a2.002,2.002,0,0,1,2,2v2.3335A1.6684,1.6684,0,0,1,30.3335,30Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3335,20h-2.667A1.6665,1.6665,0,0,0,18,21.6665V30h2V26h2v4h2V21.6665A1.6665,1.6665,0,0,0,22.3335,20ZM20,24V22h2v2Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1,22v6.5A1.4727,1.4727,0,0,0,2.5,30H7V28H3V22H7V20H3A2.0059,2.0059,0,0,0,1,22Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsCmas.propTypes = iconPropTypes;
}
const CicsDb2Connection = /*#__PURE__*/React.forwardRef(function CicsDb2Connection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,31c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9348,.364-1.8137,1.0249-2.4749l4.9998-4.9996c.6609-.6613,1.54-1.0255,2.4753-1.0255,1.9299,0,3.5,1.5701,3.5,3.5,0,.9346-.3638,1.8134-1.0244,2.4742l-1.4146-1.4138c.283-.2832,.439-.6598,.439-1.0604,0-.8271-.6729-1.5-1.5-1.5-.4009,0-.7776,.1561-1.061,.4396l-4.9998,4.9998c-.2832,.2833-.4392,.66-.4392,1.0607,0,.8271,.6729,1.5,1.5,1.5,.4011,0,.7783-.1564,1.0618-.4404l1.4155,1.4131c-.6616,.6625-1.5413,1.0273-2.4773,1.0273Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2c-5.2979,0-11,1.252-11,4V24c0,1.6797,2.134,2.7979,5,3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937,.749,3.6738,1.2153,6,1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723,5.2979,0,11-1.252,11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995ZM6.9985,6.0151c.1523-.5552,3.1514-2.0151,9.0015-2.0151,5.7976,0,8.7949,1.4341,8.9968,2-.2019,.5659-3.1992,2-8.9968,2-5.8501,0-8.8491-1.46-9.0015-1.9849Zm18.0015,5.9722c-.1606,.5571-3.1587,2.0127-9,2.0127-5.8501,0-8.8491-1.46-9-2v-3.5723c2.1279,1.0674,5.6426,1.5723,9,1.5723s6.8721-.5049,9-1.5723v3.5596Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsDb2Connection.propTypes = iconPropTypes;
}
const CicsExplorer = /*#__PURE__*/React.forwardRef(function CicsExplorer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsExplorer.propTypes = iconPropTypes;
}
const CicsProgram = /*#__PURE__*/React.forwardRef(function CicsProgram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "8",
    r: "1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsProgram.propTypes = iconPropTypes;
}
const CicsSit = /*#__PURE__*/React.forwardRef(function CicsSit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L30 27 23 32 23 22z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsSit.propTypes = iconPropTypes;
}
const CicsSitOverrides = /*#__PURE__*/React.forwardRef(function CicsSitOverrides({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M31.707,20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141,0l-9.293,9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906,.3906-1.0234,0-1.4141Zm-7.4141,6l-2.7073,2.707h-1.5857v-1.5859l2.707-2.707,2.293-2.293,1.5859,1.5859-2.293,2.293Zm3.707-3.707l-1.5859-1.5859,1.5859-1.5859,1.5857,1.5859-1.5857,1.5859Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h4Zm-6-2H4v-7H14v7ZM5,5H25c.5515,0,1,.4482,1,1v3H4v-3c0-.5518,.4485-1,1-1ZM14,27H5c-.5515,0-1-.4482-1-1v-6H14v7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsSitOverrides.propTypes = iconPropTypes;
}
const CicsSystemGroup = /*#__PURE__*/React.forwardRef(function CicsSystemGroup({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H23V4h5V28H23v2h5a2.0059,2.0059,0,0,0,2-2V4A2.0059,2.0059,0,0,0,28,2Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M14,17H8a.9448.9448,0,0,0-1,1v6a.9448.9448,0,0,0,1,1h6a.9448.9448,0,0,0,1-1V18A.9448.9448,0,0,0,14,17Zm-1,6H9V19h4Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M25,24V18a.9448.9448,0,0,0-1-1H18a.9448.9448,0,0,0-1,1v6a.9448.9448,0,0,0,1,1h6A1.0021,1.0021,0,0,0,25,24Zm-2-1H19V19h4Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M14,7H8A.9448.9448,0,0,0,7,8v6a.9448.9448,0,0,0,1,1h6a.9448.9448,0,0,0,1-1V8A.9448.9448,0,0,0,14,7Zm-1,6H9V9h4Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M18,15h6a.9448.9448,0,0,0,1-1V8a.9448.9448,0,0,0-1-1H18a.9448.9448,0,0,0-1,1v6A1.0021,1.0021,0,0,0,18,15Zm1-6h4v4H19Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsSystemGroup.propTypes = iconPropTypes;
}
const CicsTransactionServerZos = /*#__PURE__*/React.forwardRef(function CicsTransactionServerZos({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "10",
    r: "2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "22",
    r: "2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsTransactionServerZos.propTypes = iconPropTypes;
}
const CicsWuiRegion = /*#__PURE__*/React.forwardRef(function CicsWuiRegion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H16V20H14v8.6A1.4529,1.4529,0,0,0,15.5,30h3A1.4529,1.4529,0,0,0,20,28.6V20H18Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsWuiRegion.propTypes = iconPropTypes;
}
const CicsRegion = /*#__PURE__*/React.forwardRef(function CicsRegion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsRegion.propTypes = iconPropTypes;
}
const CicsRegionAlt = /*#__PURE__*/React.forwardRef(function CicsRegionAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M31,13v-2h-4c-1.1028,0-2,.8975-2,2v2c0,1.1025,.8972,2,2,2h2v2h-4v2h4c1.1028,0,2-.8975,2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M17,13v6c0,1.1025,.8972,2,2,2h4v-2h-4v-6h4v-2h-4c-1.1028,0-2,.8975-2,2Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13L11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1,13v6c0,1.1025,.8972,2,2,2H7v-2H3v-6H7v-2H3c-1.1028,0-2,.8975-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsRegionAlt.propTypes = iconPropTypes;
}
const CicsRegionRouting = /*#__PURE__*/React.forwardRef(function CicsRegionRouting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsRegionRouting.propTypes = iconPropTypes;
}
const CicsRegionTarget = /*#__PURE__*/React.forwardRef(function CicsRegionTarget({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M26 7H28V10H26z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M29 4H32V6H29z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H28V3H26z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H25V6H22z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CicsRegionTarget.propTypes = iconPropTypes;
}
const Cicsplex = /*#__PURE__*/React.forwardRef(function Cicsplex({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M8,18.6V17H6v1.6A7.3833,7.3833,0,0,0,13.4,26H15V24H13.4A5.3775,5.3775,0,0,1,8,18.6Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18H20a2.0059,2.0059,0,0,0-2,2v8a2.0059,2.0059,0,0,0,2,2h8a2.0059,2.0059,0,0,0,2-2V20A2.0059,2.0059,0,0,0,28,18ZM20,28V20h8v8Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13.4V15h2V13.4A7.3833,7.3833,0,0,0,18.6,6H17V8h1.6A5.3775,5.3775,0,0,1,24,13.4Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M12,2H4A2.0059,2.0059,0,0,0,2,4v8a2.0059,2.0059,0,0,0,2,2h8a2.0059,2.0059,0,0,0,2-2V4A2.0059,2.0059,0,0,0,12,2ZM4,12V4h8v8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Cicsplex.propTypes = iconPropTypes;
}
const CircleFilled = /*#__PURE__*/React.forwardRef(function CircleFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "10"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CircleFilled.propTypes = iconPropTypes;
}
const CircleOutline = /*#__PURE__*/React.forwardRef(function CircleOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-7.732,0-14,6.268-14,14s6.268,14,14,14,14-6.268,14-14S23.732,2,16,2Zm0,26c-6.6274,0-12-5.3726-12-12s5.3726-12,12-12,12,5.3726,12,12-5.3726,12-12,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CircleOutline.propTypes = iconPropTypes;
}
const CircleSolid = /*#__PURE__*/React.forwardRef(function CircleSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CircleSolid.propTypes = iconPropTypes;
}
const CircleDash = /*#__PURE__*/React.forwardRef(function CircleDash({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7,4.7a14.7,14.7,0,0,0-3,3.1L6.3,9A13.26,13.26,0,0,1,8.9,6.3Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6,12.3l-1.9-.6A12.51,12.51,0,0,0,2,16H4A11.48,11.48,0,0,1,4.6,12.3Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,20.4a14.4,14.4,0,0,0,2,3.9l1.6-1.2a12.89,12.89,0,0,1-1.7-3.3Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,27.3a14.4,14.4,0,0,0,3.9,2l.6-1.9A12.89,12.89,0,0,1,9,25.7Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,2.7l.6,1.9A11.48,11.48,0,0,1,16,4V2A12.51,12.51,0,0,0,11.7,2.7Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.53,11.53,0,0,1,23,25.7Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4,19.7l1.9.6A15.47,15.47,0,0,0,30,16H28A11.48,11.48,0,0,1,27.4,19.7Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2,11.6a14.4,14.4,0,0,0-2-3.9L25.6,8.9a12.89,12.89,0,0,1,1.7,3.3Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,4.6a14.4,14.4,0,0,0-3.9-2l-.6,1.9a12.89,12.89,0,0,1,3.3,1.7Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,29.3l-.6-1.9A11.48,11.48,0,0,1,16,28v2A21.42,21.42,0,0,0,20.3,29.3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CircleDash.propTypes = iconPropTypes;
}
const CircleFill = /*#__PURE__*/React.forwardRef(function CircleFill({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
      cx: "8",
      cy: "8",
      r: "6"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "6"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CircleFill.propTypes = iconPropTypes;
}
const WatsonHealthCircleMeasurement = /*#__PURE__*/React.forwardRef(function WatsonHealthCircleMeasurement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthCircleMeasurement.propTypes = iconPropTypes;
}
const CirclePacking = /*#__PURE__*/React.forwardRef(function CirclePacking({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CirclePacking.propTypes = iconPropTypes;
}
const CircleStroke = /*#__PURE__*/React.forwardRef(function CircleStroke({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
      d: "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CircleStroke.propTypes = iconPropTypes;
}
const QCircuitComposer = /*#__PURE__*/React.forwardRef(function QCircuitComposer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QCircuitComposer.propTypes = iconPropTypes;
}
const Classification = /*#__PURE__*/React.forwardRef(function Classification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "19",
    r: "1"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Classification.propTypes = iconPropTypes;
}
const ClassifierLanguage = /*#__PURE__*/React.forwardRef(function ClassifierLanguage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V2H22v8h3v4H23v2h7V14H27V10ZM24,4h4V8H24Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M7,9.86a4,4,0,1,0-2,0V14H2v2H9V14H7ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ClassifierLanguage.propTypes = iconPropTypes;
}
const Clean = /*#__PURE__*/React.forwardRef(function Clean({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H26V20H20z",
    transform: "rotate(-180 23 19)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H30V28H24z",
    transform: "rotate(-180 27 27)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H28V24H22z",
    transform: "rotate(-180 25 23)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Clean.propTypes = iconPropTypes;
}
const Close = /*#__PURE__*/React.forwardRef(function Close({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 16L24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Close.propTypes = iconPropTypes;
}
const CloseFilled = /*#__PURE__*/React.forwardRef(function CloseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2 l2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9 l5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloseFilled.propTypes = iconPropTypes;
}
const CloseLarge = /*#__PURE__*/React.forwardRef(function CloseLarge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 16L26 7.4141 24.5859 6 16 14.5859 7.4143 6 6 7.4141 14.5859 16 6 24.5859 7.4143 26 16 17.4141 24.5859 26 26 24.5859 17.4141 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloseLarge.propTypes = iconPropTypes;
}
const CloseOutline = /*#__PURE__*/React.forwardRef(function CloseOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12 S22.6,28,16,28z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloseOutline.propTypes = iconPropTypes;
}
const ClosedCaption = /*#__PURE__*/React.forwardRef(function ClosedCaption({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M15,21H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5v2H10v6h5Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M25,21H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5v2H20v6h5Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ClosedCaption.propTypes = iconPropTypes;
}
const ClosedCaptionAlt = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H25V19H19z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H17V19H11z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H9V19H6z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H26V15H22z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H20V15H13z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H11V15H6z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ClosedCaptionAlt.propTypes = iconPropTypes;
}
const ClosedCaptionFilled = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ClosedCaptionFilled.propTypes = iconPropTypes;
}
const Cloud = /*#__PURE__*/React.forwardRef(function Cloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Cloud.propTypes = iconPropTypes;
}
const CloudAlerting = /*#__PURE__*/React.forwardRef(function CloudAlerting({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudAlerting.propTypes = iconPropTypes;
}
const CloudAuditing = /*#__PURE__*/React.forwardRef(function CloudAuditing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudAuditing.propTypes = iconPropTypes;
}
const CloudDataOps = /*#__PURE__*/React.forwardRef(function CloudDataOps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H30V28H28z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26V28H24z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H22V28H20z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M22.175,10,23.76,8.7339A9.9522,9.9522,0,0,0,17.89,5.1816,10.0025,10.0025,0,0,0,6.17,13.1152,7.5054,7.5054,0,0,0,.0544,21.4087,7.6843,7.6843,0,0,0,7.7692,28H16V26H7.6945a5.632,5.632,0,0,1-5.6023-4.4858,5.5064,5.5064,0,0,1,4.4339-6.4307l1.3486-.2441.2139-1.11a8.206,8.206,0,0,1,6.7426-6.6426,7.9666,7.9666,0,0,1,3.0137.13A7.8037,7.8037,0,0,1,22.175,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudDataOps.propTypes = iconPropTypes;
}
const CloudDownload = /*#__PURE__*/React.forwardRef(function CloudDownload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudDownload.propTypes = iconPropTypes;
}
const CloudLogging = /*#__PURE__*/React.forwardRef(function CloudLogging({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H30V6H18z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H30V10H18z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H24V14H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudLogging.propTypes = iconPropTypes;
}
const CloudMonitoring = /*#__PURE__*/React.forwardRef(function CloudMonitoring({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudMonitoring.propTypes = iconPropTypes;
}
const CloudOffline = /*#__PURE__*/React.forwardRef(function CloudOffline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,12.1362a8.8694,8.8694,0,0,0-.9795-2.5434L30,3.4142,28.5872,2,2,28.5872,3.4142,30l5-5H23.5a6.4974,6.4974,0,0,0,1.3008-12.8638ZM23.5,23H10.4141L22.3418,11.0723a6.9049,6.9049,0,0,1,.6006,2.0708l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,23Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2964,23.4487l1.4313-1.4311A4.4774,4.4774,0,0,1,8.144,14.019l.8155-.0639.0991-.812a6.9867,6.9867,0,0,1,10.63-5.0865l1.4431-1.4428A8.9859,8.9859,0,0,0,7.2,12.1362,6.4891,6.4891,0,0,0,4.2964,23.4487Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudOffline.propTypes = iconPropTypes;
}
const CloudServiceManagement = /*#__PURE__*/React.forwardRef(function CloudServiceManagement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudServiceManagement.propTypes = iconPropTypes;
}
const CloudUpload = /*#__PURE__*/React.forwardRef(function CloudUpload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudUpload.propTypes = iconPropTypes;
}
const CloudApp = /*#__PURE__*/React.forwardRef(function CloudApp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8289,13.1155A10.02,10.02,0,0,0,16,5.0005V7a8.0233,8.0233,0,0,1,7.8649,6.4934l.2591,1.346,1.3488.2441A5.5019,5.5019,0,0,1,24.5076,26H16v2h8.5076a7.5019,7.5019,0,0,0,1.3213-14.8845Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H14V26H8z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H6V26H4z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H14V22H6z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20H4V22H2z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H14V18H8z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H6V18H4z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H14V14H10z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8V14H6z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H14V10H12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudApp.propTypes = iconPropTypes;
}
const CloudCeiling = /*#__PURE__*/React.forwardRef(function CloudCeiling({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H11V30H2z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28H30V30H21z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudCeiling.propTypes = iconPropTypes;
}
const CloudFoundry_1 = /*#__PURE__*/React.forwardRef(function CloudFoundry_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24H11a2,2,0,0,1-2-2V19a2,2,0,0,1,2-2h3v2H11v3h3Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M21,15V13H19a2,2,0,0,0-2,2v2H16v2h1v5h2V19h2V17H19V15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudFoundry_1.propTypes = iconPropTypes;
}
const CloudFoundry_2 = /*#__PURE__*/React.forwardRef(function CloudFoundry_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M15,23H9a2,2,0,0,1-2-2V11A2,2,0,0,1,9,9h6v2H9V21h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudFoundry_2.propTypes = iconPropTypes;
}
const CloudRegistry = /*#__PURE__*/React.forwardRef(function CloudRegistry({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H23a2.0023,2.0023,0,0,1-2-2V23a2.0023,2.0023,0,0,1,2-2h5a2.0023,2.0023,0,0,1,2,2v5A2.0023,2.0023,0,0,1,28,30Zm-5-7h-.0012L23,28h5V23Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H11a2.0023,2.0023,0,0,1-2-2V11a2.0023,2.0023,0,0,1,2-2H21a2.0023,2.0023,0,0,1,2,2v5H21V11H11V21h5Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudRegistry.propTypes = iconPropTypes;
}
const CloudSatellite = /*#__PURE__*/React.forwardRef(function CloudSatellite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudSatellite.propTypes = iconPropTypes;
}
const CloudSatelliteConfig = /*#__PURE__*/React.forwardRef(function CloudSatelliteConfig({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudSatelliteConfig.propTypes = iconPropTypes;
}
const CloudSatelliteLink = /*#__PURE__*/React.forwardRef(function CloudSatelliteLink({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudSatelliteLink.propTypes = iconPropTypes;
}
const CloudSatelliteServices = /*#__PURE__*/React.forwardRef(function CloudSatelliteServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudSatelliteServices.propTypes = iconPropTypes;
}
const CloudServices = /*#__PURE__*/React.forwardRef(function CloudServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CloudServices.propTypes = iconPropTypes;
}
const Cloudy = /*#__PURE__*/React.forwardRef(function Cloudy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Cloudy.propTypes = iconPropTypes;
}
const WatsonHealthCobbAngle = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17V15a2,2,0,0,0-2-2H10a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h8A2,2,0,0,0,20,17ZM10,15h8v2H10Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M23.42,24.48A2,2,0,0,0,21,23.06l-7.73,2.07a2,2,0,0,0-1.42,2.44h0l.52,1.93A2,2,0,0,0,14.27,31a3,3,0,0,0,.52-.07l7.73-2.07h0a2,2,0,0,0,1.41-2.45ZM14.27,29l-.51-1.94L21.48,25,22,26.92Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M13.24,6.86,21,8.93h0a2.24,2.24,0,0,0,.51.07,2,2,0,0,0,1.94-1.48L24,5.58a2,2,0,0,0-1.41-2.45L14.79,1.06a2,2,0,0,0-2.45,1.41h0l-.52,1.93a2,2,0,0,0,1.42,2.44Zm1-3.86L22,5.07,21.48,7,13.76,4.93Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21H16V23H14z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H16V11H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthCobbAngle.propTypes = iconPropTypes;
}
const Code = /*#__PURE__*/React.forwardRef(function Code({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 15H26.080000000000002V17H5.91z",
    transform: "rotate(-75 15.996 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Code.propTypes = iconPropTypes;
}
const CodeHide = /*#__PURE__*/React.forwardRef(function CodeHide({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CodeHide.propTypes = iconPropTypes;
}
const CodeReference = /*#__PURE__*/React.forwardRef(function CodeReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
    transform: "rotate(-74.995 16.96 10)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CodeReference.propTypes = iconPropTypes;
}
const CodeBlock = /*#__PURE__*/React.forwardRef(function CodeBlock({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 3H10V5H2z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M6 9H30V11H6z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M6 15H30V17H6z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 27H10V29H2z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M6 21H22V23H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CodeBlock.propTypes = iconPropTypes;
}
const CodeSigningService = /*#__PURE__*/React.forwardRef(function CodeSigningService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H8V16H6z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H4V16H2z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V14H18z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M14,16H12a2,2,0,0,1-2-2V10a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v4A2,2,0,0,1,14,16Zm-2-2h2V10H12Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H4V26H2z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H16V22H14z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M10,26H8a2,2,0,0,1-2-2V20a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v4A2,2,0,0,1,10,26ZM8,24h2V20H8Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V6H2z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H16V6H14z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H20V6H18z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6H8A2,2,0,0,1,6,4V2H8V4h2V2h2V4A2,2,0,0,1,10,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CodeSigningService.propTypes = iconPropTypes;
}
const Cognitive = /*#__PURE__*/React.forwardRef(function Cognitive({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Cognitive.propTypes = iconPropTypes;
}
const Collaborate = /*#__PURE__*/React.forwardRef(function Collaborate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M6,21V20H4v1a7,7,0,0,0,7,7h3V26H11A5,5,0,0,1,6,21Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M24,11v1h2V11a7,7,0,0,0-7-7H16V6h3A5,5,0,0,1,24,11Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11H5a3,3,0,0,0-3,3v2H4V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V14A3,3,0,0,0,11,11Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10A4,4,0,1,0,4,6,4,4,0,0,0,8,10ZM8,4A2,2,0,1,1,6,6,2,2,0,0,1,8,4Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M27,25H21a3,3,0,0,0-3,3v2h2V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V28A3,3,0,0,0,27,25Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20a4,4,0,1,0,4-4A4,4,0,0,0,20,20Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,26,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Collaborate.propTypes = iconPropTypes;
}
const CollapseAll = /*#__PURE__*/React.forwardRef(function CollapseAll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CollapseAll.propTypes = iconPropTypes;
}
const CollapseCategories = /*#__PURE__*/React.forwardRef(function CollapseCategories({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25H28V27H14z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15H28V17H14z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5H28V7H14z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CollapseCategories.propTypes = iconPropTypes;
}
const ColorPalette = /*#__PURE__*/React.forwardRef(function ColorPalette({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "12",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "18",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "23",
    r: "2"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ColorPalette.propTypes = iconPropTypes;
}
const ColorSwitch = /*#__PURE__*/React.forwardRef(function ColorSwitch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ColorSwitch.propTypes = iconPropTypes;
}
const Column = /*#__PURE__*/React.forwardRef(function Column({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H26V28H24z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M18,6V26H14V6h4m0-2H14a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H8V28H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Column.propTypes = iconPropTypes;
}
const ColumnDelete = /*#__PURE__*/React.forwardRef(function ColumnDelete({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14V28H18V6H16V28a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V14Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,10,30ZM4,8V28h6V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ColumnDelete.propTypes = iconPropTypes;
}
const ColumnInsert = /*#__PURE__*/React.forwardRef(function ColumnInsert({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H22a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM22,10V28h6V10Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H4a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,4,8h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,10,30ZM4,10V28h6V10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ColumnInsert.propTypes = iconPropTypes;
}
const ColumnDependency = /*#__PURE__*/React.forwardRef(function ColumnDependency({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ColumnDependency.propTypes = iconPropTypes;
}
const Commit = /*#__PURE__*/React.forwardRef(function Commit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Commit.propTypes = iconPropTypes;
}
const CommunicationUnified = /*#__PURE__*/React.forwardRef(function CommunicationUnified({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17H18a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h4V25H18V19H28v6H25.4648l-2.5937,3.8906L24.5352,30l2-3H28a2.0025,2.0025,0,0,0,2-2V19A2.0025,2.0025,0,0,0,28,17Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6667,24.1086l.8614-.8615a.8334.8334,0,0,1,.8988-.1844l1.0493.42A.8334.8334,0,0,1,12,24.2561v1.9082a.8334.8334,0,0,1-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316,0,0,1,2.8343,17H4.7085a.8335.8335,0,0,1,.7737.5238l.42,1.0493a.8332.8332,0,0,1-.1845.8988l-.8614.8614A4.5267,4.5267,0,0,0,8.6667,24.1086Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H28V11H21z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5H30V7H21z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M17,6,14,8.2V6a2.0024,2.0024,0,0,0-2-2H4A2.0024,2.0024,0,0,0,2,6v6a2.0024,2.0024,0,0,0,2,2h8a2.0024,2.0024,0,0,0,2-2V9.8L17,12ZM4,12V6h8v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  CommunicationUnified.propTypes = iconPropTypes;
}
const Compare = /*#__PURE__*/React.forwardRef(function Compare({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Compare.propTypes = iconPropTypes;
}
const Compass = /*#__PURE__*/React.forwardRef(function Compass({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7.5",
    r: "1.5"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Compass.propTypes = iconPropTypes;
}
const QComposerEdit = /*#__PURE__*/React.forwardRef(function QComposerEdit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QComposerEdit.propTypes = iconPropTypes;
}
const Concept = /*#__PURE__*/React.forwardRef(function Concept({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Concept.propTypes = iconPropTypes;
}
const ConditionPoint = /*#__PURE__*/React.forwardRef(function ConditionPoint({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M10.343 10.343H21.657V21.657H10.343z",
    transform: "rotate(-45 16 16)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConditionPoint.propTypes = iconPropTypes;
}
const ConditionWaitPoint = /*#__PURE__*/React.forwardRef(function ConditionWaitPoint({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M10.343 10.343H21.657V21.657H10.343z",
    transform: "rotate(-45 16 16)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConditionWaitPoint.propTypes = iconPropTypes;
}
const Connect = /*#__PURE__*/React.forwardRef(function Connect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z",
    transform: "translate(0 .01)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Connect.propTypes = iconPropTypes;
}
const ConnectRecursive = /*#__PURE__*/React.forwardRef(function ConnectRecursive({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectRecursive.propTypes = iconPropTypes;
}
const ConnectReference = /*#__PURE__*/React.forwardRef(function ConnectReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectReference.propTypes = iconPropTypes;
}
const ConnectSource = /*#__PURE__*/React.forwardRef(function ConnectSource({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectSource.propTypes = iconPropTypes;
}
const ConnectTarget = /*#__PURE__*/React.forwardRef(function ConnectTarget({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10l-1.4141,1.4141L22.1719,15H11.8989a5,5,0,1,0,0,2h10.273l-3.586,3.5859L20,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectTarget.propTypes = iconPropTypes;
}
const ConnectionReceive = /*#__PURE__*/React.forwardRef(function ConnectionReceive({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H10V18H8z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H16V12H14z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H16V18H14z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H10V24H8z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H16V24H14z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectionReceive.propTypes = iconPropTypes;
}
const ConnectionSend = /*#__PURE__*/React.forwardRef(function ConnectionSend({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H10V18H8z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H16V12H14z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H16V18H14z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H10V24H8z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H16V24H14z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectionSend.propTypes = iconPropTypes;
}
const ConnectionTwoWay = /*#__PURE__*/React.forwardRef(function ConnectionTwoWay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H10V18H8z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H16V12H14z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H16V18H14z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H10V24H8z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H16V24H14z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectionTwoWay.propTypes = iconPropTypes;
}
const ConnectionUsage = /*#__PURE__*/React.forwardRef(function ConnectionUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17,26V6c0-1.1046-.8954-2-2-2H4v2h11v20c0,1.1046.8954,2,2,2h11v-2h-11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectionUsage.propTypes = iconPropTypes;
}
const ConnectionFlowUsage = /*#__PURE__*/React.forwardRef(function ConnectionFlowUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22,16l-1.4141,1.4141,4.5859,4.5859h-10.1719V5c0-1.1046-.8954-2-2-2H3v2h10v17c0,1.1046.8954,2,2,2h10.1719l-4.5859,4.5859,1.4141,1.4141,7-7-7-7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectionFlowUsage.propTypes = iconPropTypes;
}
const ConnectionSignal = /*#__PURE__*/React.forwardRef(function ConnectionSignal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V30H15z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M11.33,18.22a7,7,0,0,1,0-10.44l1.34,1.49a5,5,0,0,0,0,7.46Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M20.67,18.22l-1.34-1.49a5,5,0,0,0,0-7.46l1.34-1.49a7,7,0,0,1,0,10.44Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4,21.8a11,11,0,0,1,0-17.6L9.6,5.8a9,9,0,0,0,0,14.4Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6,21.8l-1.2-1.6a9,9,0,0,0,0-14.4l1.2-1.6a11,11,0,0,1,0,17.6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectionSignal.propTypes = iconPropTypes;
}
const ConnectionSignalOff = /*#__PURE__*/React.forwardRef(function ConnectionSignalOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M21,13a5.0022,5.0022,0,0,1-.9023,2.8564l1.4277,1.4278a6.9831,6.9831,0,0,0-.8584-9.5015l-1.334,1.49A5.0077,5.0077,0,0,1,21,13Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.5859,3.4143,2,2,3.4141l3.71,3.71A10.9824,10.9824,0,0,0,8.3994,21.8008l1.2012-1.6A8.9678,8.9678,0,0,1,7.1714,8.5854l2.1963,2.1963a6.9664,6.9664,0,0,0,1.9648,7.4351l1.334-1.49A5.0072,5.0072,0,0,1,11,13a4.8854,4.8854,0,0,1,.0393-.5464L15,16.4141V30h2V18.4141L28.5857,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ConnectionSignalOff.propTypes = iconPropTypes;
}
const Constraint = /*#__PURE__*/React.forwardRef(function Constraint({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,13V5s-4,0-4,0v-2h4c1.1028,0,2,.8975,2,2v8c0,1.5234.8799,2,2,2v2c-1.1201,0-2,.4502-2,2v8c0,1.1025-.8972,2-2,2h-4v-2h4s0-8,0-8c0-1.6841.8799-2.5645,2-2.8584v-.2676c-1.1201-.2939-2-1.1899-2-2.874Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M12 12H20V20H12z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m5,13V5h4v-2h-4c-1.1028,0-2,.8975-2,2v8c0,1.5234-.8799,2-2,2v2c1.1201,0,2,.4502,2,2v8c0,1.1025.8972,2,2,2h4v-2h-4v-8c0-1.6841-.8799-2.5645-2-2.8584v-.2676c1.1201-.2939,2-1.1899,2-2.874Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Constraint.propTypes = iconPropTypes;
}

export { ChatBot, ChatLaunch, ChatOff, ChatOperational, Checkbox, CheckboxChecked, CheckboxCheckedFilled, CheckboxIndeterminate, CheckboxIndeterminateFilled, Checkmark, CheckmarkFilled, CheckmarkFilledError, CheckmarkFilledWarning, CheckmarkOutline, CheckmarkOutlineError, CheckmarkOutlineWarning, Chemistry, ChemistryReference, ChevronDown, ChevronDownOutline, ChevronLeft, ChevronMini, ChevronRight, ChevronSort, ChevronSortDown, ChevronSortUp, ChevronUp, ChevronUpOutline, ChildNode, Chip, Choices, ChooseItem, ChoroplethMap, CicsCmas, CicsDb2Connection, CicsExplorer, CicsProgram, CicsRegion, CicsRegionAlt, CicsRegionRouting, CicsRegionTarget, CicsSit, CicsSitOverrides, CicsSystemGroup, CicsTransactionServerZos, CicsWuiRegion, Cicsplex, CircleDash, CircleFill, CircleFilled, CircleOutline, CirclePacking, CircleSolid, CircleStroke, Classification, ClassifierLanguage, Clean, Close, CloseFilled, CloseLarge, CloseOutline, ClosedCaption, ClosedCaptionAlt, ClosedCaptionFilled, Cloud, CloudAlerting, CloudApp, CloudAuditing, CloudCeiling, CloudDataOps, CloudDownload, CloudFoundry_1, CloudFoundry_2, CloudLogging, CloudMonitoring, CloudOffline, CloudRegistry, CloudSatellite, CloudSatelliteConfig, CloudSatelliteLink, CloudSatelliteServices, CloudServiceManagement, CloudServices, CloudUpload, Cloudy, Code, CodeBlock, CodeHide, CodeReference, CodeSigningService, Cognitive, Collaborate, CollapseAll, CollapseCategories, ColorPalette, ColorSwitch, Column, ColumnDelete, ColumnDependency, ColumnInsert, Comments, Commit, CommunicationUnified, Compare, Compass, Concept, ConditionPoint, ConditionWaitPoint, Connect, ConnectRecursive, ConnectReference, ConnectSource, ConnectTarget, ConnectionFlowUsage, ConnectionReceive, ConnectionSend, ConnectionSignal, ConnectionSignalOff, ConnectionTwoWay, ConnectionUsage, Constraint, QCircuitComposer, QComposerEdit, WatsonHealthCircleMeasurement, WatsonHealthCobbAngle };
